// スクロールで [data-c-reveal] 要素をフェード表示（IntersectionObserver・多重初期化ガード・section:load対応）
(() => {
  'use strict';

  if (window.cRevealReady) return;
  window.cRevealReady = true;

  const initReveal = (scope = document) => {
    const root = scope.querySelectorAll ? scope : document;
    const targets = Array.from(root.querySelectorAll('[data-c-reveal]'));
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach((target) => target.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    targets.forEach((target) => {
      if (target.classList.contains('is-visible')) return;
      observer.observe(target);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initReveal());
  document.addEventListener('shopify:section:load', (event) => initReveal(event.target));
})();
